<template>
    <div>
        <vue-headful :title="(this.id ? 'Edit' : 'Create') + ' [Product Contract Status] - AMOS365'" />

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/admin/settings#contract-statuses">Settings</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page" v-if="!status.id">Create Product Contract Status</li>
                <li class="breadcrumb-item active" aria-current="page" v-else>Edit Product Contract Status</li>

            </ol>
        </nav>

        <h4 class="page-header">
            <span v-if="id">Edit: {{ status.contract_status_name }}</span>
            <span v-else>Create Product Contract Status</span>
        </h4>

        <div class="row">
            <div class="col-lg-8">
                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Details</strong>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.contract_status_name, 'text-muted-no': !errors.contract_status_name}">
                                Status Name: <i class="fa fa-asterisk text-danger fa-sm"></i>
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <input type="text" v-model="status.contract_status_name" :class="{'form-control': true, 'is-invalid': errors.contract_status_name}" placeholder="Enter Status Name" />

                                <div class="text-danger mt-1" v-if="errors.contract_status_name">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.contract_status_name">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.contract_status_type, 'text-muted-no': !errors.contract_status_type}">
                                Status Type: <i class="fa fa-asterisk text-danger fa-sm"></i>
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <b-form-select v-model="status.contract_status_type" :options="statusTypeOptions" :class="{'is-invalid': errors.contract_status_type}" />

                                <div class="text-danger mt-1" v-if="errors.contract_status_type">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.contract_status_type">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.contract_status_color, 'text-muted-no': !errors.contract_status_color}">
                                Status Color:
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <b-form-select v-model="status.contract_status_color" :options="statusColorOptions" :class="{'is-invalid': errors.contract_status_color}" />

                                <div :class="'mt-2 mb-2 alert alert-'+status.contract_status_color" v-if="status.contract_status_color">
                                    <span>Example of Color Highlighting with a <span :class="'badge badge-'+status.contract_status_color">Badge or Button</span></span>
                                </div>

                                <div class="text-danger mt-1" v-if="errors.contract_status_color">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.contract_status_color">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.contract_status_desc, 'text-muted-no': !errors.contract_status_desc}">
                                Description:
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <b-form-textarea v-model="status.contract_status_desc" :class="{'is-invalid': errors.contract_status_desc}" placeholder="Enter Contract Status Description" rows="4" />

                                <div class="text-danger mt-1" v-if="errors.contract_status_desc">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.contract_status_desc">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.include_on_downline, 'text-muted-no': !errors.include_on_downline}">
                                Include on Downline:
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <b-form-checkbox v-model="status.include_on_downline" :value="1" :unchecked-value="0" plain>
                                    If checked, contracts with this status will be included on the downline report
                                </b-form-checkbox>

                                <div class="text-danger mt-1" v-if="errors.include_on_downline">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.include_on_downline">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.display_as_inactive, 'text-muted-no': !errors.display_as_inactive}">
                                Display as Inactive
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <b-form-checkbox v-model="status.display_as_inactive" :value="1" :unchecked-value="0" plain>
                                    If checked, contracts with this status will be grayed when displayed on the agent profile
                                </b-form-checkbox>

                                <div class="text-danger mt-1" v-if="errors.display_as_inactive">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.display_as_inactive">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-sm btn-success" v-on:click="postCode()" :disabled="saving">
                    <template v-if="saving"><i class="fa fa-spinner fa-spin"></i> Saving</template>
                    <template v-else>Save Product Contract Status</template>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    import { VueEditor, Quill } from "vue2-editor";

    export default {
        components: {
            VueEditor,
            Quill,
        },

        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                errors: {},
                status: {},

                customToolbar: [
                    [
                        {
                            header: [false, 1, 2, 3, 4, 5, 6]
                        }
                    ],
                    ["bold", "italic", "underline", "strike"], // toggled buttons
                    [
                        {
                            align: ""
                        },
                        {
                            align: "center"
                        },
                        {
                            align: "right"
                        },
                        {
                            align: "justify"
                        }
                    ],
                    ["blockquote"],
                    [
                        {
                            list: "ordered"
                        },
                        {
                            list: "bullet"
                        },
                        {
                            list: "check"
                        }
                    ],
                    [
                        {
                            indent: "-1"
                        },
                        {
                            indent: "+1"
                        }
                    ], // outdent/indent
                    [
                        {
                            color: []
                        },
                        {
                            background: []
                        }
                    ], // dropdown with defaults from theme
                    ["link"],
                ],

                editorSettings: {
                    modules: {
                        toolbar: {
                            container: [
                                [
                                    {
                                        header: [false, 1, 2, 3, 4, 5, 6]
                                    }
                                ],
                                ["bold", "italic", "underline", "strike"], // toggled buttons
                                [
                                    {
                                        align: ""
                                    },
                                    {
                                        align: "center"
                                    },
                                    {
                                        align: "right"
                                    },
                                    {
                                        align: "justify"
                                    }
                                ],
                                ["blockquote"],
                                [
                                    {
                                        list: "ordered"
                                    },
                                    {
                                        list: "bullet"
                                    },
                                    {
                                        list: "check"
                                    }
                                ],
                                [
                                    {
                                        indent: "-1"
                                    },
                                    {
                                        indent: "+1"
                                    }
                                ], // outdent/indent
                                [
                                    {
                                        color: []
                                    },
                                    {
                                        background: []
                                    }
                                ], // dropdown with defaults from theme
                                ["link"], [] // remove formatting button
                            ],
                        },
                    },
                },
            }
        },

        watch: {

        },

        computed: {
            statusTypeOptions(){
                return [
                    {value: null, text: '-- Select Status Type --'},
                    {value: 'Pending', text: 'Pending'},
                    {value: 'Active', text: 'Active'},
                    {value: 'Ovr Only', text: 'Ovr Only'},
                    {value: 'Inactive', text: 'Inactive'},
                ];
            },

            statusColorOptions(){
                return [
                    {value: null, text: '-- Select Status color --'},
                    {value: 'primary', text: 'Primary'},
                    {value: 'secondary', text: 'Secondary'},
                    {value: 'success', text: 'Success'},
                    {value: 'danger', text: 'Danger'},
                    {value: 'warning', text: 'Warning'},
                    {value: 'info', text: 'Info'},
                    {value: 'light', text: 'Light'},
                ];
            }
        },

        methods: {
            getCode(){
                //Send it
                this.$http.get('/admin/contract-statuses' + (this.id ? '/'+this.id : ''))
                    .then(response => {
                        //Set Data
                        this.status = response.data.status;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            postCode(){
                //Saving
                this.saving = true;

                //Send it
                this.$http.post('/admin/contract-statuses', this.status)
                    .then(response => {
                        //Alert the user
                        this.$toastr.s('Product Contract Status Saved');

                        //Set Back to Settings
                        this.$router.push('/admin/settings#contract-statuses');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted() {
            //Get the Data
            this.getCode();
        }
    }
</script>